import Layout from "@/layout/index.vue";
const toiletImagesManager = {
    path: '/toiletImage',
    component: Layout,
    redirect: 'noRedirect',
    name: 'toiletImage',
    meta: {
        title: '',
        icon: 'DocumentCopy'
    },
    children: [
        {
            path: 'image',
            component: () => import('@/views/toiletImage/index.vue'),
            name: 'image',
            meta: { title: '地址图片', noCache: true,icon: 'DocumentCopy'  }
        },
    ]

}

export default toiletImagesManager
